// -------------------------------------
// Dependencies
// -------------------------------------

import './_reviews-toggle.scss';

if (document.getElementById('ReviewsToggle')) {
    document.getElementById("ReviewsToggle").onclick = function(event) {
        event.preventDefault();
        var e = document.getElementById("fulfilled-reviews-all");
        const icon = document.getElementsByClassName("reviews--toggle-icon")[0];

        if ( e.style.display == 'block') {
            e.style.display = 'none';
            document.getElementById("ReviewsToggleText").innerHTML = "Open ";
            icon.style.transform = 'rotate(0deg)';

        } else {
            e.style.display = 'block';
            document.getElementById("ReviewsToggleText").innerHTML = "Close";
            icon.style.transform = 'rotate(180deg)';
        }
    }
}